import React, { useState } from 'react';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import { Modal, Spin } from 'antd';
import Rating from '../Rating/Rating';
import { createSanitizedHTML } from '../../utils/sanitize';

const style = {
  heading: {
    paddingBottom: '10px',
    color: '#f1c400',
    fontWeight: 700,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  margin: {
    marginTop: '25px',
  },
  summary: {
    maxHeight: '400px',
    overflow: 'auto',
  },
};

const InfoModal = ({ visible, info, onCancel }) => (
  <Modal visible={visible} title={info?.category?.name || 'Hazard Detail'} footer={null} onCancel={onCancel}>
    <div style={style.heading}>RATING</div>
    <Rating percent={info.rating} />
    <div style={{ ...style.heading, ...style.margin }}>RISK SUMMARY</div>
    <div style={style.summary} dangerouslySetInnerHTML={createSanitizedHTML(info.comment)} />
  </Modal>
);

export default ({ data = [], industryName, height = 500, direction = 'vertical', embedded = false, onChartReady }) => {
  const [clickedClass, setClickedClass] = useState(null);
  const [infoModalVisible, setInfoModalVisible] = useState(false);
  const hasResolvedData = Array.isArray(data);
  const safeData = hasResolvedData ? data : [];

  const onClick = (param) => {
    setClickedClass(safeData[param.dataIndex]);
    setInfoModalVisible(true);
  };

  const displayData = safeData.filter((item) => item?.category?.name !== 'Product Recall / Product Contamination');
  const hazardClasses = displayData.map((item) => item?.category?.name).filter(Boolean);
  const hazardRatings = displayData.map((item) => item.rating);
  const vertical = direction === 'vertical';
  const xAxis = {
    type: 'category',
    axisLabel: { interval: 0, rotate: vertical ? 45 : 0 },
    data: hazardClasses,
  };
  const yAxis = { type: 'value', max: 100, min: 0 };
  const options = {
    title: {
      text: `Industry: ${industryName}`,
      subtext: embedded ? null : 'click the bar to view details',
      show: true,
      left: 'center',
      textStyle: {
        color: 'rgba(0, 0, 0, 0.65)',
        fontSize: 16,
      },
    },
    tooltip: {},
    legend: {},
    grid: { containLabel: true },
    xAxis: vertical ? xAxis : yAxis,
    yAxis: vertical ? yAxis : xAxis,
    series: [
      {
        type: 'bar',
        // animation: !embedded,
        animation: false,
        data: hazardRatings,
        itemStyle: { color: '#CB2C30' },
      },
    ],
  };
  let chartContent = <Spin className="loading" />;
  if (hasResolvedData && displayData.length > 0) {
    chartContent = (
      <ReactEchartsCore
        echarts={echarts}
        option={options}
        notMerge
        onChartReady={onChartReady}
        style={{ height: '100%' }}
        onEvents={{ click: onClick }}
      />
    );
  } else if (hasResolvedData) {
    chartContent = (
      <div className="widget-alert-wrapper">
        <div>No Hazard Index data available</div>
      </div>
    );
  }

  return (
    <div className="widget" style={{ height: `${height}px` }}>
      {chartContent}
      {clickedClass && (
        <InfoModal visible={infoModalVisible} info={clickedClass} onCancel={() => setInfoModalVisible(false)} />
      )}
    </div>
  );
};
